
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[slug]/checkout",
      function () {
        return require("private-next-pages/events/[slug]/checkout/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[slug]/checkout"])
      });
    }
  